export var ARROW_DIRECTION = {
  left: 'right',
  right: 'left',
  top: 'bottom',
  bottom: 'top'
};